/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_AcceptInputs */

const cs_addr_sugg_accept = /** @type {(inputs: Addr_Sugg_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přijmout`)
};

const en_addr_sugg_accept = /** @type {(inputs: Addr_Sugg_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Addr_Sugg_AcceptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_accept = /** @type {((inputs?: Addr_Sugg_AcceptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_AcceptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_accept(inputs)
	return cs_addr_sugg_accept(inputs)
});